import { NgModule } from '@angular/core';
import { BERetailInventoryInputFormComponent } from './inventory-input-form/be-retail-inventory-input-form.component';
import { BERetailInventoryInputDesignComponent } from './inventory-input-design/be-retail-inventory-input-design.component';
import { BERetailInventoryInputResultComponent } from './inventory-input-result/be-retail-inventory-input-result.component';
import { DynamicBERetailInventoryInputComponent } from './dynamic-be-retail-inventory-input.component';
import { BERetailInventoryInputArticlesDialog } from './inventory-input-articles-dialog/be-retail-inventory-input-articles-dialog.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { DropdownModule } from '../../dropdown/dropdown.module';
import { KendoModule } from '../../kendo.module';
import { NewlandScannerModule } from '../../newland-scanner/newland-scanner.module';
import { BERetailInventoryInputService } from './be-retail-inventory-input.service';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
    declarations: [
        BERetailInventoryInputResultComponent,
        BERetailInventoryInputDesignComponent,
        BERetailInventoryInputFormComponent, DynamicBERetailInventoryInputComponent,
        BERetailInventoryInputArticlesDialog
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatSelectModule,
        MatTableModule,
        MatProgressBarModule,
        DropdownModule,
        KendoModule,
        NewlandScannerModule,
        NgxMatSelectSearchModule,
        ScrollingModule
    ],
    entryComponents: [
        DynamicBERetailInventoryInputComponent,
        BERetailInventoryInputArticlesDialog
    ],
    providers: [
        BERetailInventoryInputService
    ]
})
export class BERetailInventoryInputModule {}